export default __webpack_public_path__ + "static/media/Telugu_cm_2.f3ca2065.mp3";